import { ServerMode } from '@zip/yi-core';
import { constants, urlsByEnvironment } from '../constants/constants';
import { FeatureFlagEnvironment } from '@zip/feature-flag-js';

const env = 'production';

export const environment = {
  production: true,
  environment: env,
  apiHost: 'https://zip.co/giftcards/api',
  v2ApiUri: 'https://api.zip.co/loyalty/giftcards',
  shopCentralUri: 'https://api.zip.co/shop/central/public',
  appPrefix: '/giftcards',
  checkoutmobileUrl: 'co.zip://deeplink/giftcards',
  giphyApiKey: 'P1kAaAWgyMA5CcusF0vSZvBie38DiwTX',
  s3Bucket: 'https://static.zipmoney.com.au',
  zipAnalytics: {
    appId: '86f12201-9421-4e8f-8887-c35d1d644ba1',
    endpoint: 'trx.zip.co',
    namespace: 'global-web',
  },
  zipIdp: {
    issuer: 'https://zip.co/login',
    clientId: 'zip-wallet-experiences-spa-1f9811e3-441e-4262-9bb9-a22dd3149c20',
  },
  zipAuth0: {
    domain: 'https://auth.zip.co',
    clientId: 'Bu8I7jnmt3Bt0eLWtDDopDBYfbj9jyni',
    audience: 'https://api.zip.co',
    scope: 'openid profile offline_access',
  },
  zipYi: {
    env: ServerMode.P,
    appId: 'd5a095a5',
  },
  zipFeatureFlag: {
    env: FeatureFlagEnvironment.Prod,
    deploymentKey: 'client-WkVTQbnwRl1Tb3UJ3T93KU4iT2UBeuf0',
  },
  zipMobileSSO: {
    domain: 'auth.zip.co',
    seamlessLoginPageClientId: 'YCyQ1JaYOqM4vmLSMJWfTI7JLRObh2nC',
    audience: 'https://api.zip.co',
  },
  ...constants,
  ...urlsByEnvironment(env),
};
